<template>
  <div class="vgt-global-search vgt-clearfix" style="width: 100%">
    <div class="vgt-global-search__input vgt-pull-left">
      <input
        v-model="model.search_value"
        type="text"
        ref="order_history"
        placeholder="Search by order#|name|contact"
        class="vgt-input vgt-pull-left"
      />
      <span class="input__icon ts-cursor-pointer"
        ><div class="magnifying-glass"></div
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Object
    }
  },
  data () {
    return {
      model: {
        search_value: ''
      }
    }
  },
  created () {
    this.model = this.value
  },
  methods: {
    onEnter () {
      this.$emit('onEnter')
    }
  }
}
</script>
